import {NgModule} from '@angular/core';
import {Route, RouterModule, Routes} from '@angular/router';
// services
import {IsNotLoggedPageGuard} from '../services/auth/is-not-logged.guard';
// shared
import {CrystalClearFrontUrl} from '../shared/pages/crystal-clear-front-url';
// crystal
import {LoginComponent} from '../crystal/login/login.component';
import {MainLayoutComponent} from '../crystal/layout/main/main-layout.component';
// crystal-clear
import {OwnerComponent} from '../crystal-clear/customer/owner/owner.component';
import {CustomerComponent} from '../crystal-clear/customer/customer/customer.component';
import {AccountComponent} from '../crystal-clear/customer/account/account.component';
import {RecapProfileComponent} from '../crystal-clear/archive/recap/recap-profile/recap-profile.component';
import {UserComponent} from '../crystal-clear/security/user/user.component';
import {ClearingViewsComponent} from '../crystal-clear/clearing/views/clearing-views.component';
import {AcceptanceRuleComponent} from '../crystal-clear/customer/acceptance-rule/acceptance-rule.component';
import {CustomerLimitsComponent} from '../crystal-clear/customer/customer-limits/customer-limits.component';
import {BrokerComponent} from '../crystal-clear/customer/broker/broker.component';
import {BankAccountComponent} from '../crystal-clear/customer/bank-account/bank-account.component';
import {AccountTraderComponent} from '../crystal-clear/customer/account-trader/account-trader.component';
import {VatRateComponent} from '../crystal-clear/customer/vat-rate/vat-rate.component';
import {MoneyOwnerComponent} from '../crystal-clear/customer/money-owner/money-owner.component';
import {BrokerageTableComponent} from '../crystal-clear/customer/brokerage-table/brokerage-table.component';
import {CrystalClearFrontUrlCustomer} from '../shared/pages/crystal-clear-front-url-customer';
import {CrystalClearFrontUrlInternal} from '../shared/pages/crystal-clear-front-url-internal';
import {UserViewComponent} from '../crystal-clear/internal/user-view/user-view.component';
import {CrystalClearFrontUrlTools} from '../shared/pages/crystal-clear-front-url-tools';
import {SchedulerViewComponent} from '../crystal-clear/tools/scheduler-view/scheduler-view.component';
import {ReportFormComponent} from "../crystal-clear/archive/form/report-form/report-form.component";
import {HomeLayoutComponent} from "../crystal/layout/home/home-layout.component";
import {SyncComponent} from "../crystal-clear/support/sync/sync.component";
import {ReportTasksComponent} from "../crystal-clear/archive/report-tasks/report-tasks.component";
import {IsLoggedPageGuard} from "../services/auth/is-logged.guard";
import {FeatureEnabledGuard} from "../services/auth/feature-enabled.guard";
import {AppConfigService} from "../services/app-config.service";
import {TraderComponent} from '../crystal-clear/customer/trader/trader.component';
import {ReportProfileComponent} from "../crystal-clear/archive/profile/report-profile/report-profile.component";
import {PageDescription} from "../shared/pages/page-description";
import {RecapTasksComponent} from "../crystal-clear/archive/recap/recap-tasks/recap-tasks.component";
import {CrystalClearFrontUrlExchange} from "../shared/pages/crystal-clear-front-url-exchange";
import {ClearingHouseComponent} from "../crystal-clear/exchange/clearing-house/clearing-house.component";
import {ExchangeDetailComponent} from "../crystal-clear/exchange/exchange/exchange-detail.component";
import {AccountTypeComponent} from "../crystal-clear/exchange/account-type/account-type.component";
import {TradingEnvironmentComponent} from "../crystal-clear/exchange/trading-environment/trading-environment.component";
import {ContractComponent} from "../crystal-clear/exchange/contract/contract.component";
import {
  MaturityRejectionRuleComponent
} from "../crystal-clear/exchange/maturity-rejection-rule/maturity-rejection-rule.component";
import {OwnerCodeComponent} from "../crystal-clear/exchange/owner-code/owner-code.component";
import {BrokerCodeComponent} from "../crystal-clear/exchange/broker-code/broker-code.component";
import {CrystalClearFrontUrlMapping} from "../shared/pages/crystal-clear-front-url-mapping";
import {
  OrderReferencePatternComponent
} from "../crystal-clear/mapping/order-reference-pattern/order-reference-pattern.component";
import {SourceComponent} from "../crystal-clear/mapping/source/source.component";
import {FeeComponent} from "../crystal-clear/mapping/fee/fee.component";
import {
  SrcMappingAccountCodeComponent
} from "../crystal-clear/mapping/src-mapping-account-code/src-mapping-account-code.component";
import {
  SrcMappingExchangeComponent
} from "../crystal-clear/mapping/src-mapping-exchange/src-mapping-exchange.component";
import {
  SrcMappingContractComponent
} from "../crystal-clear/mapping/src-mapping-contract/src-mapping-contract.component";
import {
  SrcMappingBrokerCodeComponent
} from "../crystal-clear/mapping/src-mapping-broker-code/src-mapping-broker-code.component";
import {SrcMappingTraderComponent} from "../crystal-clear/mapping/src-mapping-trader/src-mapping-trader.component";
import {SrcMappingFeeComponent} from "../crystal-clear/mapping/src-mapping-fee/src-mapping-fee.component";
import {
  SrcMappingTradeTypeComponent
} from "../crystal-clear/mapping/src-mapping-trade-type/src-mapping-trade-type.component";
import {RecapFormComponent} from "../crystal-clear/archive/recap/form/recap-form.component";
import {UserGroupComponent} from "../crystal-clear/security/user-group/user-group.component";
import {NotifyComponent} from "../crystal-clear/tools/notify/notify.component";
import {CrystalClearFrontUrlETicket} from "../shared/pages/crystal-clear-front-url-eticket";
import {NewETicketComponent} from "../crystal-clear/e-ticket/new-e-ticket/new-e-ticket.component";
import {ETicketViewsComponent} from "../crystal-clear/e-ticket/views/e-ticket-views.component";
import {ExecTraderComponent} from "../crystal-clear/customer/exec-trader/exec-trader.component";
import {BillingListComponent} from "../crystal-clear/billing/list/billing-list.component";
import {InvoiceTasksComponent} from "../crystal-clear/billing/invoice-tasks/invoice-tasks.component";
import {TradeCrudComponent} from "../crystal-clear/support/trade-crud/trade-crud.component";
import {OrderCrudComponent} from "../crystal-clear/support/order-crud/order-crud.component";
import {ClearingCrudComponent} from "../crystal-clear/support/clearing-crud/clearing-crud.component";
import {CrystalClearFrontUrlSupport} from "../shared/pages/crystal-clear-front-url-support";

const appRoutes: Routes = [
  {
    path: CrystalClearFrontUrl.ROOT.path,
    pathMatch: 'full',
    redirectTo: '/' + CrystalClearFrontUrl.HOME.path,
  },
  {
    path: CrystalClearFrontUrl.HOME.path,
    pathMatch: 'full',
    redirectTo: '/' + CrystalClearFrontUrl.HOME.path,
  },
  {
    path: CrystalClearFrontUrl.LOGIN.path,
    component: LoginComponent,
    canActivate: [IsNotLoggedPageGuard],
    data: {
      title: CrystalClearFrontUrl.LOGIN.label,
      role: CrystalClearFrontUrl.LOGIN.roles
    },
  },
  {
    path: CrystalClearFrontUrl.HOME.path,
    component: HomeLayoutComponent,
    canActivate: [IsLoggedPageGuard],
    data: {
      title: CrystalClearFrontUrl.HOME.label,
    }
  },
  {
    path: '',
    component: MainLayoutComponent,
    children:
      [
        getRoute(CrystalClearFrontUrl.TRADES_ORDERS, ClearingViewsComponent),
        // ARCHIVE
        getRoute(CrystalClearFrontUrl.ARCHIVE_REPORT_FORM, ReportFormComponent),
        getRoute(CrystalClearFrontUrl.ARCHIVE_RECAP_FORM, RecapFormComponent),
        getRoute(CrystalClearFrontUrl.ARCHIVE_REPORT_PROFILE, ReportProfileComponent),
        getRoute(CrystalClearFrontUrl.ARCHIVE_RECAP_PROFILE, RecapProfileComponent),
        getRoute(CrystalClearFrontUrl.ARCHIVE_REPORT_TASKS, ReportTasksComponent),
        getRoute(CrystalClearFrontUrl.ARCHIVE_RECAP_TASKS, RecapTasksComponent),
        // BILLING
        getRoute(CrystalClearFrontUrl.ARCHIVE_BILLING_LIST, BillingListComponent, 'billingEnabled'),
        getRoute(CrystalClearFrontUrl.ARCHIVE_INVOICE_TASKS, InvoiceTasksComponent, 'billingEnabled'),
        // CUSTOMER
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_OWNER, OwnerComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER, CustomerComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT, AccountComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_ACCEPTANCE_RULE, AcceptanceRuleComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER_LIMITS, CustomerLimitsComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_BROKER, BrokerComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_BANK_ACCOUNT, BankAccountComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT_TRADER, AccountTraderComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_TRADER, TraderComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_EXEC_TRADER, ExecTraderComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_VAT_RATE, VatRateComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_MONEY_OWNER, MoneyOwnerComponent),
        getRoute(CrystalClearFrontUrlCustomer.CUSTOMER_BROKERAGE_TABLE, BrokerageTableComponent),
        // EXCHANGE
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_CLEARING_HOUSE, ClearingHouseComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_EXCHANGE, ExchangeDetailComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_ACCOUNT_TYPE, AccountTypeComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_TRADING_ENVIRONMENT, TradingEnvironmentComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_CONTRACT, ContractComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_MATURITY_REJECTION_RULE, MaturityRejectionRuleComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_OWNER_CODE, OwnerCodeComponent),
        getRoute(CrystalClearFrontUrlExchange.EXCHANGE_BROKER_CODE, BrokerCodeComponent),
        // MAPPING
        getRoute(CrystalClearFrontUrlMapping.MAPPING_ORDER_REFERENCE_PATTERN, OrderReferencePatternComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SOURCE, SourceComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_FEE, FeeComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_ACCOUNT_CODE, SrcMappingAccountCodeComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_EXCHANGE, SrcMappingExchangeComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_CONTRACT, SrcMappingContractComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_BROKER_CODE, SrcMappingBrokerCodeComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_TRADER, SrcMappingTraderComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_FEE, SrcMappingFeeComponent),
        getRoute(CrystalClearFrontUrlMapping.MAPPING_SRC_MAPPING_TRADE_TYPE, SrcMappingTradeTypeComponent),
        // INTERNAL
        getRoute(CrystalClearFrontUrlInternal.INTERNAL_USER_VIEW, UserViewComponent),
        // SECURITY
        getRoute(CrystalClearFrontUrl.SECURITY_USER, UserComponent),
        getRoute(CrystalClearFrontUrl.SECURITY_USER_GROUP, UserGroupComponent),
        // TOOLS
        getRoute(CrystalClearFrontUrlTools.TOOLS_NOTIFY, NotifyComponent, 'notificationEnabled'),
        getRoute(CrystalClearFrontUrlSupport.SUPPORT_SYNC, SyncComponent, 'supportEnabled'),
        getRoute(CrystalClearFrontUrlSupport.SUPPORT_TRADE, TradeCrudComponent, 'supportEnabled'),
        getRoute(CrystalClearFrontUrlSupport.SUPPORT_ORDER, OrderCrudComponent, 'supportEnabled'),
        getRoute(CrystalClearFrontUrlSupport.SUPPORT_CLEARING, ClearingCrudComponent, 'supportEnabled'),
        getRoute(CrystalClearFrontUrlTools.TOOLS_SCHEDULER, SchedulerViewComponent, 'schedulerEnabled'),
        // ETICKET
        getRoute(CrystalClearFrontUrlETicket.NEW_ETICKET, NewETicketComponent, 'eticketEnabled'),
        getRoute(CrystalClearFrontUrlETicket.LIST_ETICKET, ETicketViewsComponent, 'eticketEnabled'),
      ]
  },
  {
    path: '**',
    redirectTo: '/' + CrystalClearFrontUrl.HOME.path
  },
];

function getRoute(urlDesc: PageDescription, component: any, configFlag?: keyof AppConfigService): Route {
  const canActivate: any[] = [IsLoggedPageGuard];
  const data: any = {
    title: urlDesc.label,
    role: urlDesc.roles
  };
  if (configFlag) {
    canActivate.push(FeatureEnabledGuard);
    data.configFlag = configFlag;
  }
  return {
    path: urlDesc.path,
    component: component,
    canActivate: canActivate,
    data: data
  };
}

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: false,
        useHash: true,
        // scrollPositionRestoration: 'enabled',
      } // <-- debugging purposes only
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
  static readonly ROUTES = appRoutes;
}
